import React from "react";
import { message, Modal, Spin } from "antd";
import { isTrue } from "Utils/filter";
import { useAtomValue } from "jotai";
import { loginModeAtom, loginUnifySetAtom } from "Stores/SettingsStore";
import { useMount, useSearchParam } from "react-use";
import { authLogin, getLoginCount, login } from "API/auth";
import { errorMessage } from "Utils/useRequest";
import useRequestFn from "Utils/useRequestFn";
import { FormFields } from "../Components/LoginComponent/components/AccountMode";
import LoginComponent from "../Components/LoginComponent";

interface LoginProps {
    old?: boolean;
}

export default function Login({ old }: LoginProps) {
    const loginMode = useAtomValue(loginModeAtom);
    const loginUnifySet = useAtomValue(loginUnifySetAtom);

    const code = useSearchParam("code");

    useMount(() => {
        localStorage.clear();

        // 统一身份认证返回
        if (isTrue(loginMode.unifyAuthLogin) && code) {
            return loginWithCode(code);
        }

        // 如果不允许常规登录, 直接跳转到统一身份认证
        if (!isTrue(loginMode.normalAuthLogin) && !code && !old) {
            window.location.href = loginUnifySet.ssoUrl;
        }
    });

    async function loginWithCode(code: string) {
        try {
            await authLogin(code);
            onLoginSuccess();
        } catch (e) {
            Modal.error({
                content: errorMessage(e, "登录失败, 请重试"),
                onOk: () => {
                    localStorage.clear();
                    window.location.href = `https://sso.dufe.edu.cn/auth/user/logout?client_id=${loginUnifySet.clientId}`;
                },
                okText: "重新登录"
            });
        }
    }

    const [refreshCaptcha, { data: captcha }] = useRequestFn(
        async (username: string) => {
            if (!username) return "";
            const res = await getLoginCount(username);
            return res?.img;
        }
    );

    async function onFinish(data: FormFields) {
        const { username, password, code } = data;
        if (!code) {
            const img = await refreshCaptcha(data.username);
            if (!img) await doLogin(username, password, code);
        } else {
            await doLogin(username, password, code);
        }
    }

    const [doLogin] = useRequestFn(
        async (username: string, password: string, code?: string) => {
            try {
                const url = old ? "/student/loginOld" : "/student/login";
                await login(url, username, password, code);
                onLoginSuccess();
            } catch (e) {
                message.error(errorMessage(e));
            }
        }
    );

    function onLoginSuccess() {
        window.location.href = "/";
    }

    if (!isTrue(loginMode.normalAuthLogin) && !old) {
        return <Spin tip="正在登录..." spinning />;
    }

    return (
        <LoginComponent
            captcha={captcha}
            refreshCaptcha={refreshCaptcha}
            onSubmit={onFinish}
        />
    );
}
